import { clsx } from 'clsx';

import style from './style.module.scss';
import { TagGroup } from './TagGroup';

export const Tag = props => <li className={clsx(style['tag'], props.className)}>{props.children}</li>;

Tag.Group = TagGroup;
